import { TTranslation } from '@shared/types';

export const trCouponRedeemYourCoupon: TTranslation = {
  en: 'Coupon: Redeem your coupon code',
  de: 'Coupon: Löse einen Coupon-Code ein',
  fr: 'Coupon : Utilise un code de coupon',
};

export const trCouponAdd: TTranslation = {
  en: 'Add coupon code',
  de: 'Coupon Code hinzufügen',
  fr: 'Ajouter un code de coupon',
};

export const trCouponCode: TTranslation = {
  en: 'Coupon code',
  de: 'Coupon Code',
  fr: 'Code de coupon',
};

export const trCouponNotValid: TTranslation = {
  en: 'Coupon not valid',
  de: 'Coupon nicht gültig',
  fr: 'Coupon invalide',
};

export const trRemoveCouponConfirmTitle: TTranslation = {
  de: 'Coupon entfernen',
  en: 'Remove coupon',
  fr: 'Supprimer le coupon',
};

export const trRemoveCouponConfirmBody: TTranslation = {
  de: 'Möchten sie wirklich den Coupon aus ihrer Bestellung entfernen?',
  en: 'Do you really want to remove the coupon from your order?',
  fr: 'Voulez-vous vraiment supprimer le coupon de votre commande ?',
};

export const trCouponAlreadyApplied: TTranslation = {
  de: 'Coupon wurde bereits angewendet',
  en: 'Coupon already applied',
  fr: 'Coupon déjà utilisé',
};

export const trCouponNotCombinable: TTranslation = {
  de: 'Coupon kann nicht mit eingelösten Coupons kombiniert werden',
  en: 'Coupon cannot be combined with redeemed coupons',
  fr: 'Le coupon ne peut pas être combiné avec des coupons échangés.',
};
